import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ScrollVanishDirective} from './directives/scroll-vanish/scroll-vanish.directive';
import {AutoResizeTextareaDirective} from './directives/autoresize-textarea/auto-resize-textarea.directive';
import {DebounceClickDirective} from './directives/debounce-click/debounce-click.directive';
import {ThrottleClickDirective} from './directives/throttle-click/throttle-click.directive';
import {IdViewRefDirective} from './directives/id-viewref/id-viewref.directive';
import {CastPipe} from "./pipes/common.pipes";

@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
    ],
    declarations: [
        ScrollVanishDirective,
        AutoResizeTextareaDirective,
        DebounceClickDirective,
        ThrottleClickDirective,
        IdViewRefDirective,
        CastPipe
    ],
    exports: [
        FormsModule,
        ReactiveFormsModule,
        ScrollVanishDirective,
        AutoResizeTextareaDirective,
        DebounceClickDirective,
        ThrottleClickDirective,
        IdViewRefDirective,
        CastPipe
    ]
})
export class SharedModule {
}
